import FormDataAddon from 'wretch/addons/formData';
import QueryStringAddon from 'wretch/addons/queryString';

import * as R from 'ramda';

import store from '../store/store';
import logoutAction from '../actions/user/logout';
import getUserAndClientsFromStorage from './getUserAndClientsFromStorage';
import { createExpiredSessionMiddleware } from './requestErrorHandlers';
import wretch from 'wretch';
import i18n from '../i18n/config';

const logout = store.action(logoutAction(store));

let userId = null;
// eslint-disable-next-line no-unused-vars
let token = null;
let clientId = null;
let isSessionExpired = null;

const { user: userFromStorage } = getUserAndClientsFromStorage();

store.subscribe(state => {
    userId = state.user.id || null;
    token = state.user.token || null;
    clientId = state.user.selectedClientId;
    isSessionExpired =
        state.user.timestamp && Date.now() > state.user.timestamp;
});

const dealExpiredSessions = createExpiredSessionMiddleware({
    hasSessionExpired: () => isSessionExpired,
    onLogout: logout,
});

const appendHeaders = () => {
    return next => (url, opts) => {
        if (opts.context?.ssoBootstrap === true) {
            const headers = new Headers(opts.headers);
            ['x-auth-token', 'x-auth-user-id', 'x-client-id'].forEach(name =>
                headers.delete(name),
            );
            return next(url, {
                ...opts,
                headers: Object.fromEntries(headers.entries()),
            });
        }

        const storedUser = token ? {} : userFromStorage;
        let options =
            token || storedUser.token
                ? R.assocPath(
                      ['headers', 'x-auth-token'],
                      token || storedUser.token,
                      opts,
                  )
                : opts;
        options =
            clientId || storedUser.selectedClientId
                ? R.assocPath(
                      ['headers', 'x-client-id'],
                      clientId || storedUser.selectedClientId,
                      options,
                  )
                : options;
        options =
            userId || storedUser.id
                ? R.assocPath(
                      ['headers', 'x-auth-user-id'],
                      userId || storedUser.id,
                      options,
                  )
                : R.assocPath(['headers', 'x-auth-user-id'], null, options);
        // if (timestamp < Date.now()) logoutUser(); // <= Needs some tweaks
        return next(url, options);
    };
};

const appendApiConsumerKey = () => {
    return next => (url, opts) => {
        const options = R.assocPath(
            ['headers', 'api-consumer-key'],
            'mvc',
            opts,
        );
        return next(url, options);
    };
};

const appendAcceptLanguageHeader = () => {
    return next => (url, opts) => {
        const language = i18n.language || 'en-US';
        const options = R.assocPath(
            ['headers', 'Accept-Language'],
            language,
            opts,
        );
        return next(url, options);
    };
};

const w = wretch()
    .addon(FormDataAddon)
    .addon(QueryStringAddon)
    .middlewares([
        dealExpiredSessions(),
        appendHeaders(),
        appendApiConsumerKey(),
        appendAcceptLanguageHeader(),
    ]);

export default w;
